'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactInfiniteScroller = require('react-infinite-scroller');

var _reactInfiniteScroller2 = _interopRequireDefault(_reactInfiniteScroller);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Loader = require('../loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komkponenta pro nekonečný scroll - jedná se o wrapper, který doplňuje některé vlastnosti externí InfiniteScroll komponentě.
 */
// --
var InfiniteScroll = function (_React$Component) {
    (0, _inherits3.default)(InfiniteScroll, _React$Component);

    function InfiniteScroll() {
        (0, _classCallCheck3.default)(this, InfiniteScroll);
        return (0, _possibleConstructorReturn3.default)(this, (InfiniteScroll.__proto__ || (0, _getPrototypeOf2.default)(InfiniteScroll)).apply(this, arguments));
    }

    (0, _createClass3.default)(InfiniteScroll, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                bordered = _props.bordered,
                other = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'bordered']);


            var cls = (0, _classnames2.default)("items-list", className, {
                bordered: bordered
            });

            return _react2.default.createElement(
                _reactInfiniteScroller2.default,
                (0, _extends3.default)({ className: cls }, other),
                this.props.children
            );
        }
    }]);
    return InfiniteScroll;
}(_react2.default.Component);

InfiniteScroll.PropTypes = {
    initialLoad: _react2.default.PropTypes.bool,
    threshold: _react2.default.PropTypes.number,
    pageStart: _react2.default.PropTypes.number,
    loader: _react2.default.PropTypes.element,
    useWindow: _react2.default.PropTypes.bool,
    loadMore: _react2.default.PropTypes.func.isRequired,
    hasMore: _react2.default.PropTypes.bool.isRequired,
    bordered: _react2.default.PropTypes.bool // pokud je true, jsou položky zobrazeny s okrajem, standardně je false
};
InfiniteScroll.defaultProps = {
    initialLoad: true,
    threshold: 6,
    pageStart: 0,
    loader: _react2.default.createElement(_Loader2.default, null),
    useWindow: false,
    bordered: false
};
exports.default = InfiniteScroll;
;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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